import { type FC } from 'react'
import UserList from './UserList'
import { useUsersQuery } from './query'

interface ActiveUserListProps {
  filterInput: string | null
}

const ActiveUserList: FC<ActiveUserListProps> = ({ filterInput }) => {
  const { data: users, isLoading } = useUsersQuery()

  return (<UserList filterInput={filterInput} users={users} isLoading={isLoading} />)
}

export default ActiveUserList
